import type { LauraStageId } from "@/app/components/shared/types";

export const LAURA_STAGES: {
    id: LauraStageId;
    phase: "planning" | "execution";
    labelEn: string;
    labelPt: string;
}[] = [
    { id: "p0", phase: "planning", labelEn: "P0 Context", labelPt: "P0 Contexto" },
    { id: "p1", phase: "planning", labelEn: "P1 Canvas", labelPt: "P1 Canvas" },
    { id: "p2", phase: "planning", labelEn: "P2 Object", labelPt: "P2 Objeto" },
    { id: "p3", phase: "planning", labelEn: "P3 Risks", labelPt: "P3 Riscos" },
    { id: "p4", phase: "planning", labelEn: "P4 Planning", labelPt: "P4 Planejamento" },
    { id: "p5", phase: "planning", labelEn: "P5 Collection", labelPt: "P5 Coleta" },
    { id: "p6", phase: "planning", labelEn: "P6 Plan", labelPt: "P6 Plano" },
    { id: "p7", phase: "planning", labelEn: "P7 Quality", labelPt: "P7 Qualidade" },
    { id: "e0", phase: "execution", labelEn: "E0 Extract", labelPt: "E0 Extrato" },
    { id: "e1", phase: "execution", labelEn: "E1 Evidence", labelPt: "E1 Evidências" },
    { id: "e2", phase: "execution", labelEn: "E2 Analysis", labelPt: "E2 Análise" },
    { id: "e3", phase: "execution", labelEn: "E3 Findings", labelPt: "E3 Achados" },
    { id: "e4", phase: "execution", labelEn: "E4 Accountability", labelPt: "E4 Responsabilização" },
    { id: "e5", phase: "execution", labelEn: "E5 Report", labelPt: "E5 Relatório" },
    { id: "e6", phase: "execution", labelEn: "E6 Proposals", labelPt: "E6 Propostas" },
    { id: "e7", phase: "execution", labelEn: "E7 Revision", labelPt: "E7 Revisão" },
    { id: "e8", phase: "execution", labelEn: "E8 Final", labelPt: "E8 Final" },
];

export function stageLabel(id: LauraStageId, lang: string): string {
    const s = LAURA_STAGES.find((x) => x.id === id);
    if (!s) return id;
    return lang.startsWith("pt") ? s.labelPt : s.labelEn;
}
